module.exports = __webpack_public_path__ + "static/media/pers-6.f6e284ed.jpg";